import { AssignmentStep, PlanAssignmentFlow } from "Interface/interface";
import { ReactComponent as BulbIcon } from "assets/BulbIcon.svg";
import { ReactComponent as CloseIconSmall } from "assets/CloseIconSmall.svg";
import Typography from "components/common/Typography";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import "./LeftWrapper.scss";
import { setDrawerVisible } from "./PlanAssignment.slice";

const PlanAssigmentLeftWrapper = (props: any) => {
  const { isCross } = props;

  const dispatch = useAppDispatch();

  const flow: string[] | null = useAppSelector((state) => state.PlanAssignment.flow);
  const currentStep = useAppSelector((state) => state.PlanAssignment.currentStep);
  const assignmentLeft: PlanAssignmentFlow = useAppSelector((state) => state.PlanAssignment.assignmentLeft);

  const renderLeftContent = (): AssignmentStep | null => {
    const userContent = props.corpUserSelection ? assignmentLeft.userAssignmentWithList : assignmentLeft.userAssignment;
    if (flow) {
      switch (flow[currentStep]) {
        case "Plan Selection":
          return assignmentLeft.planAssignment;
        case "Member Selection":
          return userContent;
        case "Assignment Details":
          return assignmentLeft.assignmentDetails;
        case "Assignment Preview":
          return assignmentLeft.assignmentPreview;
        case "Confirmation":
          return assignmentLeft.confirmation;
        default:
          return null;
      }
    }
    return null;
  };

  const content = renderLeftContent();

  return (
    <div className={`left-wrapper ${isCross ? "full-width-cross-visible" : ""}`}>
      {isCross && (
        <div className="left-wrapper-icon" onClick={() => dispatch(setDrawerVisible(false))}>
          <CloseIconSmall />
        </div>
      )}
      <BulbIcon />
      <div className="left-side-content">
        <div className="title-subtitle-wrapper">
          <div className="selected-title">
            <Typography variant="body1" showBold color={tokens.Text.General.Secondary}>
              {content?.title}
            </Typography>
          </div>
        </div>
        <ul className="unorder-list">
          {content?.bullets.map((title: string) => {
            return (
              <li>
                <Typography variant="body2" color={tokens.Text.General.PrimaryBody}>
                  {title}
                </Typography>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default PlanAssigmentLeftWrapper;
